module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-20.e8861d8c.jpg";